<template>
    <div>
        <Table border :columns="columns" :data="data" ref="Table" id="Table" :loading="loading">
            <template slot-scope="{ row, index }" slot="businessUnit" style="width:100%">
                <Select v-model="row.businessUnit" :transfer="true" @on-change="targetItemChange(row, index, 'businessUnit')">
                    <Option v-for="item in businessUnitList" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                </Select>
            </template>
            <template slot-scope="{ row, index }" slot="department" style="width:100%">
                <Select v-model="row.department" :transfer="true" @on-change="targetItemChange(row, index, 'department')">
                    <Option v-for="item in departmentList" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                </Select>
            </template>
            <template slot-scope="{ row, index }" slot="postFun">
                <Select v-model="row.postFun" :transfer="true" @on-change="targetItemChange(row, index, 'postFun')">
                    <Option v-for="item in funcationList" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                </Select>
            </template>
            <template slot-scope="{ row, index }" slot="performancePriorities">
                <Input type="textarea" v-model="row.performancePriorities" :autosize="true"  @on-change="targetItemChange(row, index, 'performancePriorities')"/>
            </template>
            <template slot-scope="{ row, index }" slot="weight">
                <Input type="textarea" v-model="row.weight" :autosize="true"  @on-change="targetItemChange(row, index, 'weight')"/>
            </template>
            <template slot-scope="{ row, index }" slot="details">
                <Input type="textarea" v-model="row.details" :autosize="true" @on-change="targetItemChange(row, index, 'details')" />
            </template>
            <template slot-scope="{ row, index }" slot="measureTarget1">
                <Input type="textarea" v-model="row.measureTarget1" :autosize="true" @on-change="targetItemChange(row, index, 'measureTarget1')"/>
            </template>
            <template slot-scope="{ row, index }" slot="measureTarget2">
                <Input type="textarea" v-model="row.measureTarget2" :autosize="true" @on-change="targetItemChange(row, index, 'measureTarget2')"/>
            </template>
            <template slot-scope="{ row, index }" slot="measureTarget3">
                <Input type="textarea" v-model="row.measureTarget3" :autosize="true" @on-change="targetItemChange(row, index, 'measureTarget3')"/>
            </template>
            <template slot-scope="{ row, index }" slot="measureTarget4">
                <Input type="textarea" v-model="row.measureTarget4" :autosize="true" @on-change="targetItemChange(row, index, 'measureTarget4')"/>
            </template>
            <template slot-scope="{ row, index }" slot="measureTarget5">
                <Input type="textarea" v-model="row.measureTarget5" :autosize="true" @on-change="targetItemChange(row, index, 'measureTarget5')"/>
            </template>
            <!-- <template slot-scope="{ row, index }" slot="relevanceTargetType">
                <Select v-model="row.relevanceTargetType" :transfer="true" @on-change="targetItemChange(row, index, 'relevanceTargetType')">
                    <Option v-for="item in TargetType" :value="item.ch_value" :key="item.code">{{ item.ch_value }}</Option>
                </Select>
            </template> -->
            <template slot="action1" slot-scope="{ row, index }">
                <Button size="small" @click="onSaveRow(row,index)"><!-- 保存 -->{{$t('Save')}}</Button>
                <Button type="error" size="small"  @click="onDeleteRow(row,index)"><!-- 删除 -->{{$t('Delete')}}</Button>
            </template>
            <template slot="action2" slot-scope="{ row, index }">
                <Button icon="ios-redo" :disabled="!row.id" size="small" @click="onShare(row,index)"></Button>
            </template>
        </Table>
        <div style="display: flex;justify-content: space-between;margin: 30px 0;">
            <Page :total="total" @on-change="pageChange"></Page>
            <div>
                <Button @click="openModal"><!-- 批量设置绩效目标 -->{{$t('Batch')}}</Button>
                <Button style="margin-left:15px" @click="addItem()"><!-- 新增 -->{{$t('Add')}}</Button>
                <Button style="margin-left:15px" @click="handelFile"><!-- 导入 -->{{$t('Import_Insert')}}</Button>
                <input type="file" ref="uploadExcel" accept=".xlsx,.xls" id="excel-file" @change="importExcel" v-show="false">
                <Button style="margin-left:15px" @click="exportData()"><!-- 导出 -->{{$t('Export_Formwork')}}</Button>
            </div>
        </div>
        <ShareUser ref="ShareUser" @onSelectList="onSelectList"></ShareUser>
        <BatchModal ref="BatchModal"></BatchModal>
    </div>
</template>

<script>
import ShareUser from "./ShareUser.vue";
import BatchModal from "./BatchModal.vue";
import axios from 'axios'
export default {
    components:{ShareUser,BatchModal},
    data(){
        return{
            loading:false,
            modal: false,
            dateYear: new Date().getFullYear(),
            formItem: {},
            positionList:[],
            departmentList:[],
            businessUnitList:[],
            funcationList:[],
            TargetType:[],
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data: [],
            targetModal: false,
            action: "/api/resource/upload",
            filename: "",
            shareId:'',
            rowYear:''
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Year'),/* 年度 */
                    key: "year",
                    align: "center",
                    minWidth: 80,
                    fixed: 'left'
                },{
                    title: this.$t('BU'),/* 业务单元 */
                    key:'businessUnitVal',
                    slot: "businessUnit",
                    align: "center",
                    minWidth: 180
                },{
                    title: this.$t('Department'),/* 部门 */
                    key:'departmentVal',
                    slot: "department",
                    align: "center",
                    minWidth: 180
                },{
                    title: this.$t('Funciton'),/* 职能 */
                    key:'postFunVal',
                    slot: "postFun",
                    align: "center",
                    minWidth: 140
                },{
                    title: this.$t('Performance_Priorities_Crux'),/* 关键绩效指标 */
                    key:'performancePriorities',
                    slot: "performancePriorities",
                    align: "center",
                    minWidth: 140
                },{
                    title: this.$t('Weight'),/* 权重 */
                    key:'weight',
                    slot: "weight",
                    align: "center",
                    minWidth: 120
                },{
                    title: this.$t('longText25'),/* 详细描述(符合SMART原则) */
                    key:'details',
                    slot: "details",
                    align: "center",
                    minWidth: 250
                },{
                    title: this.$t('Detailed_Measures_1'),/* 衡量指标1 */
                    key:'measureTarget1',
                    slot: "measureTarget1",
                    align: "center",
                    minWidth: 140
                },{
                    title: this.$t('Detailed_Measures_2'),/* 衡量指标2 */
                    key:'measureTarget2',
                    slot: "measureTarget2",
                    align: "center",
                    minWidth: 140
                },{
                    title: this.$t('Detailed_Measures_3'),/* 衡量指标3 */
                    key:'measureTarget3',
                    slot: "measureTarget3",
                    align: "center",
                    minWidth: 140
                },{
                    title: this.$t('Detailed_Measures_4'),/* 衡量指标4 */
                    key:'measureTarget4',
                    slot: "measureTarget4",
                    align: "center",
                    minWidth: 140
                },{
                    title: this.$t('Detailed_Measures_5'),/* 衡量指标5 */
                    key:'measureTarget5',
                    slot: "measureTarget5",
                    align: "center",
                    minWidth: 140
                },
                // {
                //     title: "关联目标类型",
                //     key:'relevanceTargetType',
                //     slot: "relevanceTargetType",
                //     align: "center",
                //     minWidth: 130
                // },
                {
                    title: this.$t('Action'),/* 操作 */
                    slot: "action1",
                    align: "center",
                    minWidth: 180,
                    fixed: 'right'
                },{
                    title: this.$t('Share'),/* 分享 */
                    slot: "action2",
                    align: "center",
                    minWidth: 80,
                    fixed: 'right'
                }
            ]
        },
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    created(){
        // this.getData()
    },
    methods: {
        getData(){
            let obj={
                ...this.formItem,
                ...this.pageInfo
            }
            this.loading=true
            axios.post("/achTargetSetting/selectAchTargetInfoList", obj).then((res) => {
                this.loading=false
                if(res){
                    this.data=res.data
                    this.total = parseInt(res.pageInfo.total)
                }
            })
        },
        addItem(){
            this.data.push({
                year:JSON.parse(sessionStorage.getItem('userInfo')).year,
                businessUnit:JSON.parse(sessionStorage.getItem('userInfo')).orgcode2,
                department:JSON.parse(sessionStorage.getItem('userInfo')).orgcode3,
                postFun:JSON.parse(sessionStorage.getItem('userInfo')).orgcode4,
                performancePriorities:'',
                weight:'',
                details:'',
                measureTarget1:'',
                measureTarget2:'',
                measureTarget3:'',
                measureTarget4:'',
                measureTarget5:'',
                // relevanceTargetType:''
            })
        },
        onShare(row,index) {
            this.$refs.ShareUser.modal = true;
            this.$refs.ShareUser.id = row.id;
            this.shareId=row.id,
            this.rowYear=row.year
            this.$refs.ShareUser.getData()
        },
        onSelectList(list){
            let obj={
                id:this.shareId,
                year:this.rowYear,
                typeFlag:'1',
                empList:list
            }
            this.$refs.ShareUser.loading=true
            axios.post("/achTargetSetting/shareAchTargetInfo", obj).then((res) => {
                
                if(res){
                    this.$refs.ShareUser.loading=false
                    this.$refs.ShareUser.modal=false
                    this.$Message.success(this.$t(res));
                    this.getData()
                    this.$nextTick(() => {
                        this.$refs.ShareUser.$refs.selection.selectAll(false);
                    })
                }
            })
        },
        targetItemChange(row, index, key) {
            key && this.$set(this.data[index], key, row[`${key}`]);
        },
        onSaveRow(row,index) {
            const array=[]
            for (var i = 0; i < 5; i ++) {
                array.push({...row,measure:row[`measureTarget${i+1}`]});
            }
            let obj={
                achTargetInfo:row,
                achTargetImportList:array
            }
            axios.post("/achTargetSetting/saveAchTargetInfo", obj).then((res) => {
                if(res){
                    this.$Message.success(this.$t(res));
                    this.getData()
                }
            })
        },
        onDeleteRow(row,index) {
            if(row.count>0 && row.id){
                this.$Modal.confirm({
                    title: this.$t('Delete_Share'),
                    onOk: () => {
                        axios.post("/achTargetSetting/deleteAchTargetInfo", {id:row.id}).then((res) => {
                            if(res){
                                this.$Message.success(res);
                                this.getData()
                            }
                        })
                    }
                })
            }else {
                this.$Modal.confirm({
                    title: this.$t('Are_you_sure_to_delete'),
                    onOk: () => {
                        if(row.id){
                            axios.post("/achTargetSetting/deleteAchTargetInfo", {id:row.id}).then((res) => {
                                if(res){
                                    this.$Message.success(res);
                                    this.getData()
                                }
                            })
                        }else {
                            this.data.splice(index,1)
                        }
                    }
                })
            }
            
        },
        uploadSuccess(val, file) {
            this.filename = file.name;
        },
        pageChange(val){
            this.pageInfo.pageNo = val;
            this.getData()
        },
        handelFile() {
            this.$refs.uploadExcel.click();
        },
        importExcel(e) {
            var file_name = document.getElementById('excel-file').value
            file_name = file_name.substring(file_name.lastIndexOf(".")).toLowerCase()
            var uploadFormat = ['.xlsx','.xls']
            if (file_name != uploadFormat[0] && file_name != uploadFormat[1]) {
                this.$Message.warning({
                    content: '文件类型不正确, 请选择' + uploadFormat.join(' or ') + '类型',
                    duration: 5
                })
                return
            }
            this.$importExcel('excel-file',e,'Table',(data) => {
                // this.data = this.data.concat(data)
                const array=[]
                data.forEach(async element => {
                    let wei=''
                    if(element.weight!=undefined || element.weight){
                         wei=element.weight.toString()
                    }else {
                        wei=element.weight
                    }
                   
                    console.log(wei)
                    if(wei!=undefined && wei.includes('.')){
                        // let reg=new RegExp('%','')
                        
                        // let str=wei.replace(reg,"")
                        // element.weight=str
                        element.weight=Number(wei)*100
                        console.log(element.weigh)
                    }
                    element.businessUnit=this.businessUnitList.filter(
                        item => (element.businessUnitVal == item.code ||  element.businessUnitVal == item.ch_value || element.businessUnitVal == item.en_value)
                        ).map(res => res.code)[0]
                    element.department=this.departmentList.filter(
                        item => (element.departmentVal == item.code ||  element.departmentVal == item.ch_value || element.departmentVal == item.en_value)
                        ).map(res => res.code)[0]
                    element.postFun=this.funcationList.filter(
                        item => (element.postFunVal == item.code ||  element.postFunVal == item.ch_value || element.postFunVal == item.en_value)
                        ).map(res => res.code)[0]
                    if(!element.businessUnit || !element.department || !element.postFun){
                        element.flag='1'
                        // this.$Message.error('导入内容有误,需请从页面从新选择')
                    }
                    const list=[]
                    for (var i = 0; i < 5; i ++) {
                        list.push({...element,measure:element[`measureTarget${i+1}`]});
                    }
                    array.push({
                        achTargetInfo:element,
                        achTargetImportList:list,
                        
                    })
                });
                 this.loading=true
                axios.post("/achTargetSetting/reportAchTargetInfoList", array).then((res) => {
                     this.loading=false
                    if (res) {
                        this.$Message.success('导入成功');
                    }
                    this.getData()
                });
            })
        },
        exportData(){
            this.data.forEach(el => {
                el.businessUnitVal=this.businessUnitList.filter(
                    item => el.businessUnit == item.code
                    ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))[0]
                el.departmentVal=this.departmentList.filter(
                    item => el.department == item.code
                    ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))[0]
                el.postFunVal=this.funcationList.filter(
                    item => el.postFun == item.code
                    ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))[0]
            })
            this.$nextTick(() => {
                this.$exportExcel('Table','绩效重点'+this.$nowDate.dateVal(new Date(),'YYYY-MM-DD HH-mm'))
            })
            // this.$refs.Table.exportCsv({
            //     filename: '绩效重点',
            // });
        },
        openModal(){
            this.$refs.BatchModal.targetModal = true
            // this.$refs.BatchModal.getData()
        }
    }   
}
</script>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/AchTargetSettingComponents/PerformanceFocus.vue